function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var OAuthResultTemplate = require('./ui/oauth-result.template');
var GithubOAuth = require('./oauth/github');
var TwitterOAuth = require('./oauth/twitter');
var TWITTER_PKCE_COOKIE = 'faucet_oauth_twitter_cv';
var FaucetOAuth = /*#__PURE__*/function () {
  function FaucetOAuth(app, mod) {
    _classCallCheck(this, FaucetOAuth);
    this.app = app;
    this.mod = mod;

    // Restored from server options during Faucet initialization.
    this.secret_github = null;
    this.secret_twitter = null;
    this.github = {
      client_id: 'Ov23limOzW982I05opK6',
      authorize_url: 'https://github.com/login/oauth/authorize',
      callback_url: 'https://saito.io/faucet/oauth',
      scope: 'read:user'
    };
    this.twitter = {
      client_id: 'bjdRdG5tcTBnRFY4S0hJeHRvazk6MTpjaQ',
      authorize_url: 'https://twitter.com/i/oauth2/authorize',
      callback_url: 'https://saito.io/faucet/oauth/twitter',
      scope: 'users.read tweet.read'
    };
  }

  /**
   * Authenticate credentials returned by the OAuth provider callback.
   * Returns an authenticated identity. Does not write Faucet records or pay.
   */
  return _createClass(FaucetOAuth, [{
    key: "authenticateCredentials",
    value: function () {
      var _authenticateCredentials = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var credentials,
          provider,
          code,
          state,
          publickey,
          parsed,
          _err,
          gh,
          clientId,
          callbackUrl,
          clientSecret,
          _err2,
          identity,
          tw,
          _clientId,
          redirectUri,
          code_verifier,
          _clientSecret,
          _err3,
          _err4,
          _identity,
          err,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              credentials = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              provider = String(credentials.provider || 'github').trim().toLowerCase();
              code = String(credentials.code || '').trim();
              state = String(credentials.state || '').trim();
              publickey = '';
              try {
                parsed = JSON.parse(Buffer.from(state, 'base64url').toString('utf8'));
                publickey = String((parsed === null || parsed === void 0 ? void 0 : parsed.pk) || '').trim();
              } catch (err) {
                publickey = '';
              }
              if (publickey) {
                _context.n = 1;
                break;
              }
              _err = new Error('Could not recover the Saito public key from the OAuth response.');
              _err.code = 'invalid_oauth_state';
              _err.httpStatus = 400;
              _err.title = 'Invalid OAuth state';
              _err.popupMessage = _err.message;
              throw _err;
            case 1:
              if (!(provider === 'github')) {
                _context.n = 4;
                break;
              }
              gh = this.github || {};
              clientId = String(gh.client_id || '').trim();
              callbackUrl = String(gh.callback_url || '').trim();
              clientSecret = this.secret_github;
              if (!(!clientId || !callbackUrl || !clientSecret)) {
                _context.n = 2;
                break;
              }
              _err2 = new Error('Client ID, callback URL, or client secret is missing. Configure secrets in Admin > Faucet.');
              _err2.code = 'github_oauth_not_configured';
              _err2.httpStatus = 500;
              _err2.title = 'GitHub OAuth not configured';
              _err2.popupMessage = _err2.message;
              throw _err2;
            case 2:
              _context.n = 3;
              return GithubOAuth.authenticateCredentials({
                code: code,
                clientId: clientId,
                clientSecret: clientSecret,
                redirectUri: callbackUrl
              });
            case 3:
              identity = _context.v;
              identity.publickey = publickey;
              return _context.a(2, identity);
            case 4:
              if (!(provider === 'twitter')) {
                _context.n = 8;
                break;
              }
              tw = this.twitter || {};
              _clientId = String(tw.client_id || '').trim();
              redirectUri = String(tw.callback_url || '').trim();
              code_verifier = String(credentials.code_verifier || '').trim();
              _clientSecret = this.secret_twitter;
              if (!(!_clientId || !redirectUri || !_clientSecret)) {
                _context.n = 5;
                break;
              }
              _err3 = new Error('X Client ID, callback URL, or client secret is missing. Configure secrets in Admin > Faucet.');
              _err3.code = 'twitter_oauth_not_configured';
              _err3.httpStatus = 500;
              _err3.title = 'X OAuth not configured';
              _err3.popupMessage = _err3.message;
              throw _err3;
            case 5:
              if (code_verifier) {
                _context.n = 6;
                break;
              }
              _err4 = new Error('Missing PKCE verifier for X authorization.');
              _err4.code = 'twitter_missing_pkce';
              _err4.httpStatus = 400;
              _err4.title = 'X authorization incomplete';
              _err4.popupMessage = 'Could not recover the X authorization session. Close this window and try again.';
              throw _err4;
            case 6:
              console.log('[Faucet] OAuth twitter authenticateCredentials redirect_uri=' + redirectUri);
              _context.n = 7;
              return TwitterOAuth.authenticateCredentials({
                code: code,
                clientId: _clientId,
                clientSecret: _clientSecret,
                redirectUri: redirectUri,
                code_verifier: code_verifier
              });
            case 7:
              _identity = _context.v;
              _identity.publickey = publickey;
              console.log('[Faucet] OAuth twitter identity provider_user_id=' + _identity.provider_user_id + ' username=' + _identity.provider_username + ' publickey=' + _identity.publickey);
              return _context.a(2, _identity);
            case 8:
              err = new Error('That authentication provider is not available yet.');
              err.code = 'unsupported_provider';
              err.httpStatus = 400;
              err.title = 'Authorization incomplete';
              err.popupMessage = 'That authentication provider is not available yet.';
              throw err;
            case 9:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function authenticateCredentials() {
        return _authenticateCredentials.apply(this, arguments);
      }
      return authenticateCredentials;
    }()
  }, {
    key: "attachRoutes",
    value: function attachRoutes(expressapp) {
      var oauth_self = this;
      var slug = encodeURI(this.mod.returnSlug());
      var sendPopup = function sendPopup(res, status, opts) {
        if (!res || res.writableEnded || res.finished) {
          return;
        }
        var code = Number(status);
        res.status(Number.isInteger(code) && code >= 100 && code <= 599 ? code : 500);
        res.setHeader('Content-type', 'text/html; charset=UTF-8');
        res.setHeader('Cache-Control', 'no-store');
        return res.send(OAuthResultTemplate(opts || {}));
      };
      var failPopup = function failPopup(res, status, opts) {
        try {
          return sendPopup(res, status, opts);
        } catch (err) {
          try {
            if (!res.writableEnded) {
              res.end();
            }
          } catch (endErr) {
            // client already gone
          }
        }
      };

      // TEMP DEV: skip GitHub and feed a synthetic identity into the real
      // OAuth-success path. Bound to loopback so it cannot be used as a
      // production authentication bypass.
      expressapp.get("/".concat(slug, "/oauth/test"), /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(req, res) {
          var _req$query;
          var host, publickey, identity, outcome, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (!res.finished) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                host = String(req.headers.host || '').split(':')[0].toLowerCase();
                if (!(host !== 'localhost' && host !== '127.0.0.1')) {
                  _context2.n = 2;
                  break;
                }
                res.status(404);
                return _context2.a(2, res.end());
              case 2:
                publickey = String(((_req$query = req.query) === null || _req$query === void 0 ? void 0 : _req$query.publickey) || '').trim();
                if (publickey) {
                  _context2.n = 3;
                  break;
                }
                return _context2.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'Faucet OAuth test',
                  message: 'Missing Saito public key. Open /faucet/oauth/test?publickey=<key>.'
                }));
              case 3:
                identity = {
                  provider: 'github',
                  provider_user_id: 'dev-' + publickey,
                  provider_username: 'faucet-dev',
                  provider_display_name: 'Faucet Dev',
                  provider_account_created_at: Date.now() - 200 * 24 * 60 * 60 * 1000,
                  publickey: publickey
                };
                _context2.p = 4;
                _context2.n = 5;
                return oauth_self.mod.acceptAuthenticatedIdentity(identity);
              case 5:
                outcome = _context2.v;
                return _context2.a(2, sendPopup(res, outcome.status, outcome.popup));
              case 6:
                _context2.p = 6;
                _t = _context2.v;
                console.error('FAUCET OAUTH TEST: acceptAuthenticatedIdentity failed', _t);
                return _context2.a(2, sendPopup(res, 500, {
                  ok: false,
                  title: 'Faucet OAuth test failed',
                  message: (_t === null || _t === void 0 ? void 0 : _t.message) || 'acceptAuthenticatedIdentity failed.'
                }));
            }
          }, _callee2, null, [[4, 6]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
      expressapp.get("/".concat(slug, "/oauth/github"), function (req, res) {
        var _req$query2;
        if (res.finished) {
          return;
        }
        var publickey = String(((_req$query2 = req.query) === null || _req$query2 === void 0 ? void 0 : _req$query2.publickey) || '').trim();
        if (!publickey) {
          return sendPopup(res, 400, {
            ok: false,
            title: 'GitHub sign-in unavailable',
            message: 'Missing Saito public key. Close this window and try again from Get SAITO.'
          });
        }
        var gh = oauth_self.github || {};
        var clientId = String(gh.client_id || '').trim();
        var authorizeUrl = String(gh.authorize_url || '').trim();
        var callbackUrl = String(gh.callback_url || '').trim();
        var scope = String(gh.scope || 'read:user').trim();
        if (!clientId || !authorizeUrl || !callbackUrl) {
          return sendPopup(res, 400, {
            ok: false,
            title: 'GitHub OAuth not configured',
            message: 'Public GitHub OAuth settings are incomplete on this server (client_id / callback).'
          });
        }
        try {
          var state = Buffer.from(JSON.stringify({
            pk: publickey
          }), 'utf8').toString('base64url');
          var url = new URL(authorizeUrl);
          url.searchParams.set('client_id', clientId);
          url.searchParams.set('redirect_uri', callbackUrl);
          url.searchParams.set('scope', scope);
          url.searchParams.set('state', state);
          return res.redirect(302, url.toString());
        } catch (err) {
          console.error('FAUCET OAUTH: failed to redirect to GitHub', (err === null || err === void 0 ? void 0 : err.message) || err);
          return sendPopup(res, 400, {
            ok: false,
            title: 'GitHub sign-in unavailable',
            message: 'Could not start GitHub authorization. Close this window and try again from Get SAITO.'
          });
        }
      });
      var handleTwitterOAuth = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(req, res) {
          var _req$query3, _req$query4, _req$query5, _oauth_self$twitter, _req$query7;
          var code, state, oauthError, redirect_uri, cookie_path, code_verifier, cookie_header, _iterator, _step, part, idx, name, _req$query6, desc, identity, outcome, publickey, tw, clientId, authorizeUrl, scope, pkce, _state, secure, url, _t2, _t3, _t4;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (!(res.finished || res.writableEnded)) {
                  _context3.n = 1;
                  break;
                }
                return _context3.a(2);
              case 1:
                code = String(((_req$query3 = req.query) === null || _req$query3 === void 0 ? void 0 : _req$query3.code) || '').trim();
                state = String(((_req$query4 = req.query) === null || _req$query4 === void 0 ? void 0 : _req$query4.state) || '').trim();
                oauthError = String(((_req$query5 = req.query) === null || _req$query5 === void 0 ? void 0 : _req$query5.error) || '').trim();
                redirect_uri = String(((_oauth_self$twitter = oauth_self.twitter) === null || _oauth_self$twitter === void 0 ? void 0 : _oauth_self$twitter.callback_url) || '').trim();
                cookie_path = "/".concat(slug, "/oauth/twitter");
                if (!(code || oauthError)) {
                  _context3.n = 21;
                  break;
                }
                console.log('[Faucet] OAuth twitter callback host=' + String(req.headers.host || '') + ' has_code=' + !!code + ' has_state=' + !!state + ' error=' + (oauthError || '(none)') + ' redirect_uri=' + redirect_uri);
                code_verifier = '';
                cookie_header = String(req.headers.cookie || '');
                _iterator = _createForOfIteratorHelper(cookie_header.split(';'));
                _context3.p = 2;
                _iterator.s();
              case 3:
                if ((_step = _iterator.n()).done) {
                  _context3.n = 6;
                  break;
                }
                part = _step.value;
                idx = part.indexOf('=');
                if (!(idx === -1)) {
                  _context3.n = 4;
                  break;
                }
                return _context3.a(3, 5);
              case 4:
                name = part.slice(0, idx).trim();
                if (!(name === TWITTER_PKCE_COOKIE)) {
                  _context3.n = 5;
                  break;
                }
                try {
                  code_verifier = decodeURIComponent(part.slice(idx + 1).trim());
                } catch (err) {
                  code_verifier = '';
                }
                return _context3.a(3, 6);
              case 5:
                _context3.n = 3;
                break;
              case 6:
                _context3.n = 8;
                break;
              case 7:
                _context3.p = 7;
                _t2 = _context3.v;
                _iterator.e(_t2);
              case 8:
                _context3.p = 8;
                _iterator.f();
                return _context3.f(8);
              case 9:
                res.setHeader('Set-Cookie', TWITTER_PKCE_COOKIE + '=; Path=' + cookie_path + '; HttpOnly; SameSite=Lax; Max-Age=0');
                if (!oauthError) {
                  _context3.n = 10;
                  break;
                }
                desc = String(((_req$query6 = req.query) === null || _req$query6 === void 0 ? void 0 : _req$query6.error_description) || oauthError);
                console.log('[Faucet] OAuth twitter returned error', oauthError);
                return _context3.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'X authorization failed',
                  message: desc
                }));
              case 10:
                if (!(!code || !state)) {
                  _context3.n = 11;
                  break;
                }
                return _context3.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'X authorization incomplete',
                  message: 'Missing authorization code or state.'
                }));
              case 11:
                console.log('[Faucet] OAuth twitter PKCE verifier recovered=' + !!code_verifier);
                _context3.p = 12;
                _context3.n = 13;
                return oauth_self.authenticateCredentials({
                  provider: 'twitter',
                  code: code,
                  state: state,
                  code_verifier: code_verifier,
                  redirect_uri: redirect_uri
                });
              case 13:
                identity = _context3.v;
                console.log('[Faucet] OAuth twitter handoff acceptAuthenticatedIdentity');
                _context3.n = 14;
                return oauth_self.mod.acceptAuthenticatedIdentity(identity);
              case 14:
                outcome = _context3.v;
                return _context3.a(2, sendPopup(res, outcome.status, outcome.popup));
              case 15:
                _context3.p = 15;
                _t3 = _context3.v;
                if (!((_t3 === null || _t3 === void 0 ? void 0 : _t3.code) === 'twitter_account_too_new')) {
                  _context3.n = 16;
                  break;
                }
                console.log('[Faucet] OAuth twitter account too new', _t3.username || '', _t3.created_at || '(no created_at)');
                _context3.n = 20;
                break;
              case 16:
                if (!((_t3 === null || _t3 === void 0 ? void 0 : _t3.code) === 'twitter_token_exchange_failed')) {
                  _context3.n = 17;
                  break;
                }
                console.error('[Faucet] OAuth twitter token exchange failed', _t3.message);
                _context3.n = 20;
                break;
              case 17:
                if (!((_t3 === null || _t3 === void 0 ? void 0 : _t3.code) === 'twitter_user_fetch_failed')) {
                  _context3.n = 18;
                  break;
                }
                console.error('[Faucet] OAuth twitter profile failed', _t3.message);
                _context3.n = 20;
                break;
              case 18:
                if (!(_t3 !== null && _t3 !== void 0 && _t3.httpStatus && _t3 !== null && _t3 !== void 0 && _t3.title)) {
                  _context3.n = 19;
                  break;
                }
                _context3.n = 20;
                break;
              case 19:
                console.error('[Faucet] OAuth twitter exchange/profile failed', (_t3 === null || _t3 === void 0 ? void 0 : _t3.code) || (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || _t3);
                return _context3.a(2, failPopup(res, 502, {
                  ok: false,
                  title: 'X verification failed',
                  message: 'Could not complete X token exchange or profile lookup. Try again.'
                }));
              case 20:
                return _context3.a(2, failPopup(res, _t3.httpStatus || 502, {
                  ok: false,
                  title: _t3.title || 'X verification failed',
                  message: _t3.popupMessage || _t3.message || 'Could not complete X authorization. Close this window and try again.',
                  details: _t3.details || ''
                }));
              case 21:
                publickey = String(((_req$query7 = req.query) === null || _req$query7 === void 0 ? void 0 : _req$query7.publickey) || '').trim();
                if (publickey) {
                  _context3.n = 22;
                  break;
                }
                return _context3.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'X sign-in unavailable',
                  message: 'Missing Saito public key. Close this window and try again from Get SAITO.'
                }));
              case 22:
                tw = oauth_self.twitter || {};
                clientId = String(tw.client_id || '').trim();
                authorizeUrl = String(tw.authorize_url || '').trim();
                scope = String(tw.scope || 'users.read tweet.read').trim();
                if (!(!clientId || !authorizeUrl || !redirect_uri)) {
                  _context3.n = 23;
                  break;
                }
                return _context3.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'X OAuth not configured',
                  message: 'Public X OAuth settings are incomplete on this server (client_id).'
                }));
              case 23:
                _context3.p = 23;
                pkce = TwitterOAuth.createPkce();
                _state = Buffer.from(JSON.stringify({
                  pk: publickey
                }), 'utf8').toString('base64url');
                secure = req.protocol === 'https' || String(req.headers['x-forwarded-proto'] || '').split(',')[0].trim() === 'https' ? '; Secure' : '';
                res.setHeader('Set-Cookie', TWITTER_PKCE_COOKIE + '=' + encodeURIComponent(pkce.code_verifier) + '; Path=' + cookie_path + '; HttpOnly; SameSite=Lax; Max-Age=600' + secure);
                url = new URL(authorizeUrl);
                url.searchParams.set('response_type', 'code');
                url.searchParams.set('client_id', clientId);
                url.searchParams.set('redirect_uri', redirect_uri);
                url.searchParams.set('scope', scope);
                url.searchParams.set('state', _state);
                url.searchParams.set('code_challenge', pkce.code_challenge);
                url.searchParams.set('code_challenge_method', 'S256');
                console.log('[Faucet] OAuth twitter authorize started redirect_uri=' + redirect_uri);
                return _context3.a(2, res.redirect(302, url.toString()));
              case 24:
                _context3.p = 24;
                _t4 = _context3.v;
                console.error('FAUCET OAUTH: failed to redirect to X', (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || _t4);
                return _context3.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'X sign-in unavailable',
                  message: 'Could not start X authorization. Close this window and try again from Get SAITO.'
                }));
            }
          }, _callee3, null, [[23, 24], [12, 15], [2, 7, 8, 9]]);
        }));
        return function handleTwitterOAuth(_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }();
      expressapp.get("/".concat(slug, "/oauth/twitter"), function (req, res) {
        res.on('error', function (err) {
          console.error('[Faucet] OAuth twitter response error', (err === null || err === void 0 ? void 0 : err.message) || err);
        });
        Promise.resolve().then(function () {
          return handleTwitterOAuth(req, res);
        })["catch"](function (err) {
          console.error('[Faucet] OAuth twitter route aborted', (err === null || err === void 0 ? void 0 : err.message) || err);
          failPopup(res, 502, {
            ok: false,
            title: 'X verification failed',
            message: 'Could not complete X authorization. Close this window and try again.'
          });
        });
      });
      expressapp.get("/".concat(slug, "/oauth"), /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(req, res) {
          var _req$query8, _req$query9, _req$query0;
          var code, state, oauthError, _req$query1, desc, identity, outcome, _t5;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (!res.finished) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                code = String(((_req$query8 = req.query) === null || _req$query8 === void 0 ? void 0 : _req$query8.code) || '').trim();
                state = String(((_req$query9 = req.query) === null || _req$query9 === void 0 ? void 0 : _req$query9.state) || '').trim();
                oauthError = String(((_req$query0 = req.query) === null || _req$query0 === void 0 ? void 0 : _req$query0.error) || '').trim();
                if (!(!code && !state && !oauthError)) {
                  _context4.n = 2;
                  break;
                }
                return _context4.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'Invalid OAuth callback',
                  message: 'This endpoint accepts GitHub OAuth responses only. Start again from Get SAITO.'
                }));
              case 2:
                if (!oauthError) {
                  _context4.n = 3;
                  break;
                }
                desc = String(((_req$query1 = req.query) === null || _req$query1 === void 0 ? void 0 : _req$query1.error_description) || oauthError);
                console.log('FAUCET OAUTH: GitHub returned error', oauthError);
                return _context4.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'GitHub authorization failed',
                  message: desc
                }));
              case 3:
                if (!(!code || !state)) {
                  _context4.n = 4;
                  break;
                }
                return _context4.a(2, sendPopup(res, 400, {
                  ok: false,
                  title: 'GitHub authorization incomplete',
                  message: 'Missing authorization code or state.'
                }));
              case 4:
                _context4.p = 4;
                _context4.n = 5;
                return oauth_self.authenticateCredentials({
                  provider: 'github',
                  code: code,
                  state: state
                });
              case 5:
                identity = _context4.v;
                _context4.n = 6;
                return oauth_self.mod.acceptAuthenticatedIdentity(identity);
              case 6:
                outcome = _context4.v;
                return _context4.a(2, sendPopup(res, outcome.status, outcome.popup));
              case 7:
                _context4.p = 7;
                _t5 = _context4.v;
                if (!((_t5 === null || _t5 === void 0 ? void 0 : _t5.code) === 'github_account_too_new')) {
                  _context4.n = 8;
                  break;
                }
                console.log('FAUCET OAUTH: GitHub account too new', _t5.login || '', _t5.created_at || '(no created_at)');
                _context4.n = 10;
                break;
              case 8:
                if (!(_t5 !== null && _t5 !== void 0 && _t5.httpStatus && _t5 !== null && _t5 !== void 0 && _t5.title)) {
                  _context4.n = 9;
                  break;
                }
                _context4.n = 10;
                break;
              case 9:
                console.error('FAUCET OAUTH: GitHub exchange/profile failed', (_t5 === null || _t5 === void 0 ? void 0 : _t5.code) || (_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || _t5);
                return _context4.a(2, sendPopup(res, 502, {
                  ok: false,
                  title: 'GitHub verification failed',
                  message: 'Could not complete GitHub token exchange or profile lookup. Try again.'
                }));
              case 10:
                return _context4.a(2, sendPopup(res, _t5.httpStatus, {
                  ok: false,
                  title: _t5.title,
                  message: _t5.popupMessage || _t5.message,
                  details: _t5.details || ''
                }));
            }
          }, _callee4, null, [[4, 7]]);
        }));
        return function (_x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }]);
}();
module.exports = FaucetOAuth;